import { RiWhatsappLine } from "react-icons/ri";
import { FiShoppingCart } from "react-icons/fi";

import Button from "../../elements/button";
import "./index-pricing-card.css";
import { handleWhatappMessage } from "../../../hooks/common";

export function PricingCard({
  title,
  tag,
  price,
  unit = "/mês",
  features = [],
  href = "#",
  featured = false,
  message,
}) {
  return (
    <article className={`pricing-card ${featured ? "featured" : ""}`}>
      <div className="flex ">
        <h3>{title}</h3>
        {tag && <span className="tag">{tag}</span>}
      </div>

      <div className="pricing-card-flex">
        <div>
          <div className="price">
            R$ {price}
            <small> {unit}</small>
          </div> 
          <ul className="check-list">
            {features.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        </div>

        <Button
          onClick={() =>
            handleWhatappMessage({
              name: title,
              description: message,
              price: price,
            })
          }
          target="_blank"
          className="btn-block"
        >
          <FiShoppingCart /> &nbsp; COMPRAR AGORA
        </Button>
      </div>
    </article>
  );
}

export function PricingCardFlex({
  title,
  tag,
  diagonalTag,
  price,
  unit = "/mês",
  features = [],
  href = "#",
  featured = false,
  message = "",
}) {
  return (
    <article className={`pricing-card ${featured ? "featured" : ""}`}>
      <div>
        <h3>{title}</h3>
        {tag && <span className="tag">{tag}</span>}
        {diagonalTag && <span className="diagonal-tag">{diagonalTag}</span>}
      </div>
      <div className="price">
        R$ {price}
        <small> {unit}</small>
      </div>
      <ul className="check-list">
        {features.map((f, i) => (
          <li key={i}>{f}</li>
        ))}
      </ul>
      <Button
        onClick={() =>
          handleWhatappMessage({
            name: title,
            description: message,
            price: price,
          })
        }
        target="_blank"
        className="btn-block"
      >
        <RiWhatsappLine /> &nbsp; COMPRAR AGORA
      </Button>
    </article>
  );
}